// The one syntax of a variable in a letter template: `{{name}}` or `{{order.number}}`. Both sides of the wire
// read it the same way: the server substitutes it when sending, the client shows where it stands.

/** A fresh matcher for a template variable: a new regex each time, so no shared state between calls. */
export const templateToken = () => /\{\{\s*([a-z_][a-z0-9_.]*)\s*\}\}/gi;

/** The sample a preview and a test letter show instead of a real value: «‹name›». */
export const sampleOf = (name: string) => `‹${name}›`;

/** The names of the variables in a text, in the order they appear: `{{a.b}}` → «a.b». */
export const templateVars = (text: string): string[] => {
  const names: string[] = [];
  for (const m of text.matchAll(templateToken())) if (!names.includes(m[1]!)) names.push(m[1]!);
  return names;
};
